import { Component, Input, Output, EventEmitter } from '@angular/core';
import { User, CampaignProduct, StepEmulatorDevices, StepCategoryLabels, FunnelInputTypeEnum } from '../../../_models';
import { stepLayout as stepLayoutMap } from '../../../steps-library/step-util';

@Component({
  selector: 'offer-step-card',
  templateUrl: './offer-step-card.component.html',
  styleUrls: ['./offer-step-card.component.scss'],
})
export class OfferStepCardComponent {
  activeDevice = StepEmulatorDevices.Mobile;

  @Input() step: any;
  @Input() steps: any[];
  @Input() stepsReordering: boolean;
  @Input() isHovered: boolean;
  @Input() isEnabled: boolean;
  @Input() isLoading: boolean;
  @Input() isConverting: boolean;
  @Input() isTogglingStatus: boolean;
  @Input() isAdmin: boolean;
  @Input() user: User;
  @Input() selectedProduct: CampaignProduct;
  @Input() randomProduct: CampaignProduct;
  @Input() productPlaceholderUrl: string;
  @Input() theme: string;
  @Input() stepForm: any;
  @Input() discountSetting: any;

  @Output() toggleStatus = new EventEmitter<void>();
  @Output() hoverEnter = new EventEmitter<void>();
  @Output() hoverLeave = new EventEmitter<void>();
  @Output() navigateToStep = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();
  @Output() preview = new EventEmitter<void>();
  @Output() saveAsTemplate = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<void>();

  get categoryLabel(): string {
    return StepCategoryLabels[this.step.category];
  }

  get stepLayout(): any[] {
    return stepLayoutMap[this.step.category] || [];
  }

  get isEnterTroubleshooterStep(): boolean {
    return this.step && this.step.category === FunnelInputTypeEnum.EnterTroubleshooter;
  }

  editIcon: string = '/assets/stepAssets/iframe-edit.svg';
  cloneIcon: string = '/assets/stepAssets/iframe-clone.svg';
  previewIcon: string = '/assets/stepAssets/iframe-preview.svg';
  saveTemplateIcon: string = '/assets/stepAssets/iframe-save.svg';
  saveGlobalIcon: string = '/assets/stepAssets/iframe-save.svg';
  deleteIcon: string = '/assets/stepAssets/iframe-delete.svg';
}
